import { Injectable } from '@angular/core';

import { UserService } from '../../../../index';

@Injectable({ providedIn: 'root' })
export class ProxyHeadersService {
    constructor(private user: UserService) {}

    /**
     * Generate headers for BPP Api calls.
     */
    generateBppAuthHeaders(): string | null {
        return this.user.bppToken || '';
    }

    /**
     * Generate headers for X-Corelation ID.
     */
    generateUserHeader(): string {
        return this.user.username + ':' + new Date().toISOString();
    }

    isInShopUser(): boolean {
        return this.user.isInShopUser();
    }
}
